<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Facilities" tabActive="Meitex_Vietnam" bg="/images/sub/visual/sv-facilities.jpg" />
        </template>

        <sub-section class="page-section--first">
            <div class="tit-wrap text-center">
                <h3 class="tit tit--lg">Meitex_Vietnam</h3>
            </div>

            <v-row align="center" justify="space-between" class="row--small">
                <v-col cols="12" sm="auto">
                    <h3 class="tit tit--symbol" data-aos="fade-right">니팅 공장 및 염색 공장</h3>
                </v-col>
                <v-col cols="12" sm="auto">
                    <p class="page-text grey-a--text text-right">Meitex_Vietnam</p>
                </v-col>
            </v-row>
            <v-divider class="border-2 grey-2 mt-14 mb-24 mt-md-20 mb-md-40" />

            <v-row>
                <v-col cols="12" md="4">
                    <v-row>
                        <v-col cols="6" md="12" class="">
                            <v-img class="ma-auto" src="/images/sub/facilities/vietnam4.jpg" />
                        </v-col>
                        <v-col cols="6" md="12" class="">
                            <v-img class="ma-auto" src="/images/sub/facilities/vietnam3.jpg" />
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="8">
                    <v-row>
                        <v-col cols="6" md="6">
                            <v-img height="100%" class="ma-auto" src="/images/sub/facilities/vietnam2.jpg" />
                        </v-col>
                        <v-col cols="6" md="6">
                            <v-img height="100%" class="ma-auto" src="/images/sub/facilities/vietnam1.jpg" />
                        </v-col>
                        <v-col cols="12" md="12">
                            <v-img height="100%" class="ma-auto" src="/images/sub/facilities/vietnam0.jpg" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </sub-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
    },
};
</script>

<style lang="scss" scoped></style>
